import { UploadStage } from '$/GraphQL/schema/schema';

export const stageToString = (stage: UploadStage): string => {
  switch (stage) {
    case UploadStage.Waiting:
      return 'Waiting to transcode';
    case UploadStage.Publishing:
      return 'Importing';
  }

  return stage.toString();
};
